import { useMutation } from '@tanstack/react-query';
import { renderGlobalDocxTemplate } from '@dealstack/frontend/shared/dataExchange/services/documentTemplates.service';
import { useTranslationDefault } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2.tsx';
import { isStandardBackendError } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer';
import type { PreviewRes } from '@dealstack/frontend/shared/components/FieldBinding/fieldBinding.types.ts';

interface Params {
	templateId: string;
	/** Accepted for shape-compatibility with the deal adapter and ignored: a library template
	 *  has no deal, so every render resolves against the sample recipient. */
	investorId?: string;
	document?: unknown;
	bindings?: Record<string, string>;
	scenario?: unknown;
}

export const useGlobalDocxTemplateRender = () => {
	const tDefault = useTranslationDefault();

	return useMutation({
		mutationFn: async ({
			templateId,
			document,
			bindings,
			scenario,
		}: Params): Promise<PreviewRes> =>
			await renderGlobalDocxTemplate({
				id: templateId,
				...(document === undefined ? {} : { document }),
				...(bindings === undefined ? {} : { bindings }),
				...(scenario === undefined ? {} : { scenario }),
			}),
		onError: (error: unknown) => {
			if (isStandardBackendError(error)) {
				showToastV2({
					state: 'error',
					title: tDefault(`error_codes.${error.error?.code}`),
				});
				return;
			}
			showToastV2({ state: 'error', title: tDefault('common.toast.error.message') });
		},
	});
};
